import { Entity, MicroMClient } from "@mcurros2/microm";
import { CiudadesDef } from "./CiudadesDef";

export class ProvinciasCiudades extends Entity<CiudadesDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new CiudadesDef(), parentKeys);
        this.Form = import('./ProvinciasCiudadesForm').then((module) => module.ProvinciasCiudadesForm);
        this.Title = "Ciudades";
    }
}